import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import './MyComments.css';

function MyComments() {
  const [comments, setComments] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const navigate = useNavigate();

  useEffect(() => {
    fetch('/api/comments/mine', {
      credentials: 'include',
    })
      .then((res) => {
        if (!res.ok) throw new Error('Failed to load your comments');
        return res.json();
      })
      .then((data) => {
        setComments(data);
        setLoading(false);
      })
      .catch((err) => {
        console.error(err);
        setError('Failed to load your comments. Are you logged in?');
        setLoading(false);
      });
  }, []);

  return (
    <div className="my-comments-container">
      <h2>My Comments</h2>
      {loading && <p>Loading your comments...</p>}
      {error && <p style={{ color: 'red' }}>{error}</p>}
      {!loading && comments.length === 0 && <p>You haven't posted any comments yet.</p>}
      <ul className="my-comments-list">
        {comments.map((comment) => (
          <li key={comment.id} className="my-comment-item">
            <div className="my-comment-meta">
              <strong>On map:</strong> {comment.map_name || 'Unknown'}
              <br />
              <strong>Posted:</strong> {new Date(comment.created_at).toLocaleString()}
            </div>
            <div className="my-comment-message">{comment.message}</div>
            <button
              className="go-to-map-button"
              onClick={() => navigate(`/map/${comment.map_id}`)}
            >
              Go to Map
            </button>
          </li>
        ))}
      </ul>
    </div>
  );
}

export default MyComments;
